module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_9_m.d17098a1cde661c4f49842ae6d6eae0b.png";